<div
  class="modal modal-xl fade"
  id="materialModal"
  tabindex="-1"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  aria-labelledby="materialModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5">Lista de Materiales</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row w-100" [formGroup]="formFilter">
          <div class="form-check form-switch col-6 col-md-4 d-flex">
            <div class="mb-4 col">
              <label for="actives">Mostrar solo activas</label>
              <input formControlName="onlyActiveP"
                class="form-check-input ms-0"
                type="checkbox" 
                id="actives"
                [(ngModel)]="this.onlyActiveP"
                (change)="obtenerTodo()"
              >
            </div>
          </div>
          <div class="mb-3 col ">
            <div class="d-flex align-items-center">
              <label for="controlFindMaterial" class="form-label">Buscar</label>
            </div>
            <input autocomplete="off" type="text" class="form-control" id="controlFindMaterial" placeholder="Informacion a buscar" formControlName="filter">
          </div>
          <div class="mb-3 col">
            <label for="selectOptionFindPortfolio" class="form-label">Opciones de Busqueda</label>
            <select id="selectOptionFindPortfolio" class="form-select" aria-label="Default select find option" formControlName="option">
              <option *ngFor="let column of this.columns" [value]="column.prop">{{column.name}}</option>
            </select>
          </div>
          <div class="mb-3 col">
            <label for="selectOptionCountItems" class="form-label">Cantidad de Busquedas</label>
            <select #selectItemsCount id="selectOptionCountItems" class="form-select" aria-label="Default select find option" formControlName="itemsCount">
              <option *ngFor="let items of this.itemsCounts" [value]="items">{{items}}</option>
            </select>
          </div>
        </div>
        <ng-container *ngIf="(this.dataSource$| async) as response">
          <ngx-datatable
            class="bootstrap"
            columnMode="force"
            trackByProp="pdetNumitem"
            rowHeight="auto"
            [columns]="columns"
            [rows]="response.respuesta"
            [limit]="pageSize"
            [headerHeight]="50"
            [footerHeight]="50"
            [scrollbarH]="true"
            [selectionType]="SelectionType.single"
            [selected]="selected"
            [externalPaging]="true"
            [count]="response.pagination ? response.pagination.totalItems : 0"
            [offset]="params.page ?? 0"
            [limit]="params.pageSize ?? 0"
            (select)="onSelectRow($event)"
            (page)="setPage($event)"
            *ngIf="(this.searchParamBehaviorSubject | async) as params">
          </ngx-datatable>
        </ng-container>
      </div>
      <div class="modal-footer">
        <button #btnCloseModal type="button" class="btn btn-danger" data-bs-dismiss="modal">
          <i class="fa fa-times"></i>
          <span>Cerrar</span>
        </button>
        <button type="button" class="btn btn-success" (click)="accept()" [disabled]="!selection">
          <span>Aceptar</span>
          <i class="fa fa-check"></i>
        </button>
      </div>
    </div>
  </div>
</div>
